<template>
  <div id="area-base-component">
    <div class="d-flex justify-end mb-3">
      <c-btn outlined color="blue" @click="addArea" :disabled="!inputState"> 구간추가</c-btn>
    </div>
    <div v-for="fare in fareList">
      <c-card outlined  :title="fare.area + '구간'" class="mt-4">
        <template #headItems>
          <c-btn v-if="fare.area>1" icon iconName="close" @click="deleteArea(fare.area)" :disabled="!inputState"></c-btn>
        </template>
        <v-row align="center">
          <v-col sm="3" md="2">구간 명</v-col>
          <v-col sm="9" md="10">
            <v-text-field v-model="fare.areaDescription" class="areaDescriptionValue" dense hide-details :disabled="!inputState"></v-text-field>
          </v-col>
          <v-col sm="3" md="2">기본 요금</v-col>
          <v-col sm="9" md="10">
            <v-text-field v-model="fare.unitFare" :rules="[rules.numberOnly]" class="areaUnitValue" dense :disabled="!inputState"></v-text-field> 원
          </v-col>
        </v-row>
      </c-card>
    </div>

  </div>
</template>

<script>
export default {
  name: "AreaBase",
  props: {
    fareInfo: {
      type: Object,
      default: []
    },
    inputState: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      fareList: [
        {unitFare:0, areaDescription: '',area: 1, startValue:0, endValue: 2147483647, unitValue:1}
      ],
      rules: {
        numberOnly: value => /^[0-9]*$|^null$/.test(value) || '숫자만 입력해주세요',
      }
    }
  },
  watch: {
    fareInfo: {
      deep: true,
      handler(value) {
        if(value.length > 0) {
          this.fareList = value;
        }
      }
    },
    fareList: {
      deep: true,
      handler(value) {
        this.$emit('update:fareInfo', value)
      }
    },

  },
  methods: {
    addArea() {
      const area = this.fareList.length + 1;
      this.fareList.push({
        unitFare:0, areaDescription: '', area: area, startValue:0, endValue: 2147483647, unitValue:1
      })
    },
    deleteArea(targetArea) {
      let temp = JSON.parse(JSON.stringify(this.fareList))
      temp = temp.filter(item => item.area != targetArea).map((fare,index) => {
        fare.area = index + 1;
        return fare;
      });
      this.fareList = temp;
    }
  }
}
</script>

<style scoped>
.areaDescriptionValue {
  width: 400px
}
.areaUnitValue{
  display: inline-block;
  width: 150px
}

</style>